import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { MatPaginator, MatPaginatorIntl } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { CustomMatPaginatorIntl } from "../../../../../services/customMatPaginator.service";
import { ITable } from '../../../../../models/ITable';

@Component({
    selector: 'app-table-archivos-adjuntos',
    templateUrl: '../../../../../shared/tables/table.component.html',
    styleUrls: ['../../../../../theme/styles/_common.scss'],
    providers: [{
        provide: MatPaginatorIntl,
        useClass: CustomMatPaginatorIntl
    }]
})

export class TableArchivosAdjuntos implements OnInit{
    GetImpresion: (celda: any) => any;
    GetSelected: (celda: any) => any;
    GetCellRow: (col: any, newValue: any, oldValue: any, editRowModel: any) => any;
    GetOpen: (celda: any) => any;
    Confirm: (celda: any) => any;
    BrokenImage: (event: any, celda: any) => any;
    masterToggle: () => any;
    isAllSelected: () => boolean;
    CheckboxModelChanged: (row: any, event: any, colDef: any) => any;
    ListModelChange: (row: any, event: any, colDef: any) => any;
    GetTime: (event: any, celda: any, colDef: any) => any;
    selection: { hasValue: () => any; toggle: (row: any) => any; isSelected: (row: any) => any; };
    tblEditClass: string;
    tblDataClass: string;
    search: any;
    disable: any;


    @Output() RowToEdit = new EventEmitter();
    @Output() RowToDelete = new EventEmitter();
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    Paginado: boolean = true;
    displayedColumns = [];
    public displaycolumnsDef = [];
    displayToasta: boolean = false;
    dataSource: any = [];

    ngOnInit(){
        this.dataSource = new MatTableDataSource<any>([]);
        setTimeout(() => {
            this.dataSource.sort = this.sort;
        })
    }

    SetColumnDefs(colDefs: any[]) {
        this.displaycolumnsDef = colDefs;
        this.displayedColumns = colDefs.map(c => c.columnDef);
    }
    SetData(dataSource: any[]) {
        this.dataSource = new MatTableDataSource<any>(dataSource);
        setTimeout(() => {
            this.dataSource.sort = this.sort;
        })
        this.paginator.pageSize = 20;
        this.dataSource.paginator = this.paginator;
    }

    GetEditar = (row: any) => this.RowToEdit.emit(row);
    GetElimina = (row: any, i?: any) => this.RowToDelete.emit(row);
    GetRowClass = (row: any) => '';
    SetEditRow = (row: any) => this.RowToEdit.emit(row);
    SelectedByClick(row) { }
}